import React, { useEffect, useMemo } from 'react';
import { isUndefined } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { AppBarCMS } from '../../../../basic';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { SensorForm } from './SensorForm.jsx';
import { Spinner } from '../../../../common';
import {
  useEditSensorMutation,
  useGetSensorDetailQuery,
} from '../../../../../redux/services/sensors';
import { useGetAttributeUnitsQuery } from '../../../../../redux/services/attributeUnits';
import { useToastMessages } from '../../../../../hooks/useToastMessages';
import { makeSensorAttributeInitials } from '../../../../../utils/helpers/CommonHelper';

export function SensorEditPage() {
  const { t } = useTranslation();
  const { sensorId } = useParams();
  const navigate = useNavigate();

  const { successMessage } = useToastMessages();

  const { data: sensorDetail, isLoading } = useGetSensorDetailQuery(sensorId);
  const [editSensor, { isSuccess }] = useEditSensorMutation();

  const { data: units, isLoading: isLoadingUnits } =
    useGetAttributeUnitsQuery();

  useEffect(() => {
    if (isSuccess) {
      successMessage({
        message: t('Senzor bol úspešne upravený'),
      });
      navigate(routes.cmsMeteoStationSensors);
    }
  }, [isSuccess]);

  const initials = useMemo(() => {
    if (isUndefined(sensorDetail)) return {};
    return {
      ...sensorDetail,
      sensor_attributes: sensorDetail.sensor_attributes.map((attribute) =>
        makeSensorAttributeInitials(attribute),
      ),
    };
  }, [sensorDetail]);

  return isLoading || isLoadingUnits ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Úprava senzora')}
        backUrl={routes.cmsMeteoStationSensors}
        backUrlTooltip={t('Správa senzorov')}
      />
      <div style={{ margin: '10px' }}>
        <SensorForm
          initials={initials}
          units={units}
          onSubmit={(values) => {
            editSensor({
              sensorId: sensorId,
              values,
            });
          }}
        />
      </div>
    </>
  );
}

export default SensorEditPage;
